import { serialize } from '@surveycake/logic-engine';
import { getData, getMasterSubjects, getPrivateData } from 'app/core/http';
import { Exception } from 'app/core/status';

async function initialMasterSubjects(
  surveyHash: string,
  masterHash: string,
  password?: string
) {
  try {
    return await getMasterSubjects(surveyHash, masterHash, password);
  } catch (error) {
    if (
      error.message === 'MASTER_SURVEY_IS_NOT_EXISTED' ||
      error.message === 'MASTER_SURVEY_IS_OFF'
    ) {
      throw new Exception(error.message);
    }

    throw new Exception('NOT_FOUND');
  }
}

/**
 * To get the private survey data and serialize it.
 * If it's a child survey, should get subjects from master survey.
 */
export async function initialPrivateData(surveyHash: string, password: string) {
  try {
    let { data, subjects } = await getPrivateData(surveyHash, password);
    data = serialize(data);

    if (data.masterhash) {
      subjects = await initialMasterSubjects(
        surveyHash,
        data.masterhash,
        password
      );
    }

    return { data, subjects };
  } catch (error) {
    throw error;
  }
}

/**
 * To get the survey data and serialize it.
 * If it's a child survey, should get subjects from master survey.
 */
export async function initialData(surveyHash: string, isPreview: boolean) {
  try {
    let { data, subjects } = await getData(surveyHash, isPreview);
    data = serialize(data);

    if (data.masterhash) {
      subjects = await initialMasterSubjects(surveyHash, data.masterhash);
    }

    return { data, subjects };
  } catch (error) {
    throw error instanceof Exception ? error : new Exception('NOT_FOUND');
  }
}
